import { kwls } from '@config';
const EditorFacade = require('../../../facade/editor/editor');
const DesygnerApi = require('../../../factory/desygner-api');
const ImagesFactory = require('../../../factory/images');
const UserInfoFactory = require('../../../factory/user-info');

module.exports = Backbone.View.extend({
  defaultListQueryParams: {
    inst: _.now(),
    from: 0,
    page: 1,
    total: 0,
    limit: INKIVE.C.IS_MOBILE ? 10 : 30
  },
  prices: null,

  initialize: function () {
    _.bindAll(this, '_doSearch', 'initializeDeferred', 'genericResultProcessor', 'addThumbItem', 'mapSubscriptionItem');
    this.tool = INKIVE.Tool.getInstance();
  },

  initializeDeferred: function () {
    const deferred = $.Deferred();

    if (this.initialized) {
      deferred.resolve();
    } else {
      const _products = DesygnerApi.get('payment/prices/products');
      const _userInfo = UserInfoFactory.get();
      const searchOptionsPromise = (() => {
        const deferred = $.Deferred();
        const onSearchOptionsLoaded = () => deferred.resolve();

        INKIVE.EditorFacade.on('searchOptionsLoaded', onSearchOptionsLoaded);

        setTimeout(() => {
          INKIVE.EditorFacade.off('searchOptionsLoaded', onSearchOptionsLoaded);
          deferred.resolve();
        }, 2000);

        return deferred.promise();
      })();

      $.when(_products, _userInfo, searchOptionsPromise).then(
        _.bind(function (prices, userInfo) {
          this.initialized = true;
          this.prices = prices;
          this.roles = userInfo.roles;
          this.workspaceAllowsUpselling = INKIVE.C.FEATURE_FLAG?.users?.includes('allows_user_upselling');

          deferred.resolve();
        }, this)
      );
    }

    return deferred.promise();
  },

  initSearch: function (target, opts, resultProcessor, onSearch) {
    this.$elem = $(target).find('.tab-content');
    INKIVE.Modal.loader(document.body);

    this.initializeDeferred().then(_.bind(function () {
      let refresh = false;
      this.onSearch = onSearch;
      this.resultProcessor = resultProcessor;

      if (!this.$elem.length) {
        this.$elem = $(target);
      }

      this.opts = $.extend(true, {}, this.defaultListQueryParams, {
        query: '',
        type: '',
        isAdmin: false
      }, opts);

      if (this.opts.query && this.$elem.data('query') !== this.opts.query) {
        refresh = true;
        this.$elem.data('query', this.opts.query);
      }

      $(target).find('input[name="search"]').val(this.$elem.data('query'));

      const type = this.opts.type || $(target).find('li.ui-tabs-active a').attr('data-id');
      let filterData;

      if (type.indexOf('layout') > -1) {
        const width = this.tool.editor.canvas.contentW;
        const height = this.tool.editor.canvas.contentH;

        if (type.indexOf('this') > -1) {
          filterData = {
            format_width: width,
            format_height: height
          };
        } else if (type.indexOf('prop') > -1) {
          filterData = {
            format_aspect: (width / height).toFixed(1)
          };
        }
      }

      if (type && this.$elem.data('type') !== type) {
        refresh = true;
        this.$elem.data('type', type);

        filterData
          ? this.$elem.data('filterData', filterData)
          : this.$elem.removeData('filterData');
      }

      if (refresh) {
        this.tool.clearTab(target);

        this.$elem.addThumb();

        this.$elem.data('inst', this.opts.inst);
        this.$elem.data('from', this.opts.from);
        this.$elem.data('page', this.opts.page);
        this.$elem.data('total', this.opts.total);
      }

      this.tool.initScrollDetect(this.$elem, this._doSearch);
    }, this));
  },

  _getPlanModels: function () {
    const plans = [];

    if (this._hasRole('content2')) plans.push('content2');
    if (this._hasRole('ultimate')) return [...plans, 'ultimate'];
    if (this.workspaceAllowsUpselling) return [...plans, 'enterprise'];
    if (this._hasRole('business')) return ['business'];
    if (this._hasRole('pro')) return ['pro'];

    return plans;
  },

  _hasRole: function (role) {
    return this.roles.includes(`ROLE_${role.toUpperCase()}`);
  },

  _doSearch: function (repeat, end, contents) {
    this.onSearch && this.onSearch();
    const limit = INKIVE.C.IS_MOBILE ? 10 : 30;
    const activeTab = INKIVE.Helpers.getActiveTab();
    const activeHeader = this.$elem.parents('.tab.active').find('.header-links').find('.active').attr('data-key');
    const $filterModal = $('#filter-' + activeTab + '-' + activeHeader);

    const orientationFilter = getCheckedFilters('orientation')
      .map(elem => `orientation=${elem.getAttribute('name')}`);

    const providersFilter = getCheckedFilters('providers')
      .map(elem => `provider[]=${elem.getAttribute('name')}`);

    const typesFilter = getCheckedFilters('types')
      .map(elem => elem.getAttribute('name'));

    const models = [];

    typesFilter.includes('free') && models.push('free');
    typesFilter.includes('oneoff') && models.push('oneoff');
    typesFilter.includes('plan') && models.push(...this._getPlanModels());
    typesFilter.includes('other') && models.push('business');

    if (this.workspaceAllowsUpselling) {
      (typesFilter.includes('content2') || typesFilter.includes('upsale')) && models.push('content2');
    }

    const modelsFilter = models.map(m => `model[]=${m}`);

    const params = {
      orientationFilter,
      providersFilter,
      typesFilter: modelsFilter,

      q: encodeURIComponent(this.$elem.data('query') || ''),
      from: this.$elem.data('from'),
      page: this.$elem.data('page'),
      filters: this.$elem.data('type'),

      filterData: this.$elem.data('filterData'),
      where: {
        active: this.opts.isAdmin ? 0 : 1
      }
    };

    const searchCallback = _.bind(function (r) {
      if (params && params.filters === 'mls') {
        r = { data: JSON.parse(r) };
      }

      if (params && (params.filters === 'kwls' || params.filters === 'mns') && Array.isArray(r)) {
        r = { data: r.map((response) => response.data) };
      }

      const results = r && r.data && r.data.length;
      const from = results + this.$elem.data('from');

      if (Array.isArray(r.data) && (!results || results < 1)) {
        r.data = [];
        end();

        (parseInt(this.$elem.data('from')) === 0) && this.$elem.html(
          '<label class="title text-center">' + INKIVE.TranslateHelper.translate('common.no_result') + '</label>');
      } else {
        this.resultProcessor
          ? this.resultProcessor(r.data)
          : this.genericResultProcessor(r);
      }

      if (r.status && (r.status !== 200 || (r.totalCount && from >= r.totalCount))) {
        end();
      } else if (!this.opts.skipScrollDetect) {
        this.$elem.data('from', from);
        this.$elem.data('page', r.page + 1);
        this.tool.initScroll(this.$elem.parents('.image-list'));
        repeat();
      }

      INKIVE.Modal.loaderClose(document.body);
      this.opts.callback && this.opts.callback();
    }, this);

    if (this.opts.url) {
      this.getCustomUrlSearchResult(this.opts.url, params, searchCallback, this.opts.authErrorCallback);
      return;
    }

    if (this.opts.legacy) {
      params.limit = limit;
      params.filters = params.filters + ' ' + this.opts.legacy;
      INKIVE.Helpers.api('search/search', 'GET', params, searchCallback);
      return;
    }

    this.getGenericSearchResult(params, searchCallback);

    function getCheckedFilters (name) {
      return Array.from($filterModal.find(`.${name}-filter input:checked`));
    }
  },

  getCustomUrlSearchResult: function (baseUrl, params, searchCallback, authErrorCallback) {
    let from = params.from;
    let header = null;
    let url = '';

    if (params.filters === 'kwls' || params.filters === 'mns') {
      header = {
        Authorization: `Basic ${CONFIG.api_key}`
      };

      from = Math.floor(from / kwls.pageSize) + 1;
      url = `${baseUrl}${this.opts.skipScrollDetect ? '' : from}`;
    } else {
      url = `${baseUrl}${from}`;
    }

    $.ajax({
      url,
      type: 'GET',
      headers: header,
      success: function (result) {
        if (result.error && result.error.data) {
          result = result.error;
        }
        searchCallback(result);
      },
      error: function (response) {
        const responseText = response.responseText || '';

        if (responseText.match('Unauthorized') || responseText.match('403')) {
          authErrorCallback && authErrorCallback();
        }

        searchCallback({ data: [] });
      }
    });
  },

  getGenericSearchResult: function (params, searchCallback, previousData) {
    const providers = '&' + params.providersFilter.join('&');
    const orientation = params.orientationFilter.length === 1 ? '&' + params.orientationFilter[0] : '';
    const model = params.typesFilter.length > 0
      ? '&' + params.typesFilter.join('&')
      : this.workspaceAllowsUpselling ? '&model[]=content2' : '';

    const type = params.filters.indexOf('image') > -1 ? 'Image' : 'Vector';
    const url = 'business/marketplace/search/' + type +
      '?search=' + params.q +
      '&page=' + params.page +
      providers + orientation + model;

    params.from || EditorFacade.handle('shopping_cart', 'load_widget');

    DesygnerApi.getWithHeaders(url).then((response) => {
      let mappedData = _.map(response.data, function (e) {
        const isPhoto = type === 'Image' || e.provider === INKIVE.C.SHUTTERSTOCK;
        const thumb = e.data.mobile;
        const photo = e.data.largeweb;
        const defaultSize = 155;
        let thumbWidth = thumb.width;
        let thumbHeight = thumb.height;

        if (!thumbWidth || !thumbWidth) {
          if (photo.width > photo.height) {
            thumbWidth = defaultSize;
            thumbHeight = defaultSize / e.data.aspect;
          } else {
            thumbHeight = defaultSize;
            thumbWidth = defaultSize * e.data.aspect;
          }
        }

        return {
          collection: isPhoto ? 'image' : type.toLowerCase(),
          page: params.page,
          data: {
            source: e.provider,
            id: e.id,
            originalData: e,
            name: e.description,
            url: isPhoto ? photo.url : thumb.url,
            thumb_photo: thumb.url,
            thumb_width: thumbWidth,
            thumb_height: thumbHeight,
            original_photo: photo.url,
            original_width: photo.width,
            original_height: photo.height
          }
        };
      });
      if (previousData) mappedData = previousData.concat(mappedData);

      if (params.from + mappedData.length < 30 && response.status === 200) {
        this.getGenericSearchResult(params, searchCallback, mappedData);
        params.page++;
      } else {
        searchCallback({
          data: mappedData,
          totalCount: parseInt(INKIVE.Helpers.getHeader(response.headers, 'x-total-count')),
          page: parseInt(params.page),
          status: response.status
        });
      }
    }, () => {
      searchCallback({ data: [] });
    });
  },

  genericResultProcessor: function (r) {
    const forbiddenDomains = ['pxhere.com/', 'pikist.com/', 'publicdomainpictures.net/', 'wallpaperflare.com/', 's.iha.com/'];
    const layouts = [];
    const backgrounds = [];
    const vectors = [];
    const photos = [];

    for (let i = 0; i < r.data.length; i++) {
      let imageData;
      const data = r.data[i].data;

      // Filtering out images from domains that don't allow server to server upload (WB-6785)
      const blacklisted = _.filter(forbiddenDomains, function (domain) {
        return data.original_photo.match(domain);
      });

      if (blacklisted.length) continue;

      switch (r.data[i].collection) {
        case 'layout':
          if (!data.url) {
            data.url = INKIVE.C.THUMB_NOCOVER;
          }

          layouts.push({
            id: 'layout-' + data.id,
            src: data.url,
            height: 76,
            data: {
              version: {
                thumb: data.url,
                mobile: data.url,
                tab: data.url,
                web: data.url,
                largeweb: data.url,
                original: data.url
              }
            }
          });
          break;

        case 'vector':
          vectors.push({
            provider: data.source,
            id: 'vector-' + data.id,
            src: data.url,
            thumb_width: data.thumb_width,
            thumb_height: data.thumb_height,
            width: data.thumb_width,
            height: data.thumb_height,
            data: {
              changeable: true,
              name: data.name,
              svg_url: data.original_photo,
              version: {
                thumb: data.thumb_photo || data.url,
                mobile: data.url,
                tab: data.url,
                web: data.url,
                largeweb: data.url,
                original: data.url
              }
            }
          });

          break;

        case 'image':
          imageData = {
            name: data.name,
            search: true,
            version: {
              thumb: data.thumb_photo,
              original: data.original_photo
            }
          };

          if (data.original_photo.match(/photodexia.com/)) {
            imageData.original_url = data.original_photo;
            imageData.original_width = data.original_width;
            imageData.original_height = data.original_height;
            imageData.version = ImagesFactory.getAllImageVersions(data.original_photo);
          } else if (_.contains(r.f, 'assetbank')) {
            imageData.loadType = 'ab';
            imageData.originalData = { object_id: data.id };
          }

          this.mapSubscriptionItem(imageData, data);

          ImagesFactory.addImageData(imageData);

          photos.push({
            id: 'photo-' + data.id,
            src: data.thumb_photo,
            width: data.thumb_width || 75,
            height: data.thumb_height || 75,
            data: imageData
          });

          break;

        default:
          vectors.push({
            id: 'vector-' + r.data[i].id,
            src: data.source.replace('.svg', '.png'),
            data: {
              changeable: true,
              name: data.name,
              svg_url: data.source,
              width: 75,
              height: 75
            }
          });
      }
    }

    this.addThumbItem(backgrounds, this.tool.callbackBackgrounds);
    this.addThumbItem(layouts, this.tool.callbackLayouts);
    this.addThumbItem(photos, this.tool.callbackImages);
    this.addThumbItem(vectors, this.tool.callbackStickers);
  },

  addThumbItem: function (items, callback) {
    const tool = this.tool;

    tool.addThumbItem(this.$elem, items, function (thumb, elem) {
      _.bind(callback, tool, thumb, elem)();
    });
  },

  mapSubscriptionItem: function (item, data) {
    const subscriptionModels = ['pro', 'business', 'enterprise', 'ultimate', 'content2'];
    const requiredRole = `ROLE_${data.originalData.model.toUpperCase()}`;
    const allowEnterprise = data.originalData.model === 'enterprise' && this.workspaceAllowsUpselling;

    item.originalData = data.originalData;
    item.subscription_image = subscriptionModels.includes(data.originalData.model);
    item.subscribed_user = item.subscription_image && (this.roles.includes(requiredRole) || allowEnterprise);

    /**
     * TODO: This is a temporary fix for the issue where the image is not replaced
     * assets/js/editor/factory/images.js : getAvailableImageSizes
     * This function should not use custom sizes for images from photodexia
     * Adding dimensions would make photodexia images to fail to calculate the right size
     * Thread: https://desygner-team.slack.com/archives/C01KD2D15C1/p1701134016470309
     */
    const dimensions = data.source !== 'photodexia'
      ? {
          thumb_width: data.thumb_width,
          thumb_height: data.thumb_height,
          original_width: data.original_width,
          original_height: data.original_height
        }
      : {};

    item.version = {
      ...dimensions,
      thumb: data.originalData.data.thumb.url,
      mobile: data.originalData.data.mobile.url,
      tab: data.originalData.data.tab.url,
      web: data.originalData.data.web.url,
      largeweb: data.originalData.data.largeweb.url,
      original: data.originalData.data.largeweb.url
    };
  }
});
